'use strict';
var base = require('autoship/product/base');
var baseQuickView = require('base/product/quickView');
baseQuickView.addToCart = base.addToCart;

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="quickViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <a class="full-pdp-link" href=""></a>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));
    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();
    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('#quickViewModal .modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#quickViewModal .modal-body').empty();
            $('#quickViewModal .modal-body').html(parsedHtml.body);
            $('#quickViewModal .modal-footer').html(parsedHtml.footer);
            $('#quickViewModal .full-pdp-link').text(data.quickViewFullDetailMsg);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
            $('#quickViewModal').modal('show');
            $('body').trigger('quickview:ready');

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/*
 * update add to autoship order button (enable/disable)
 * */
function updatedAddToAutoshipOrderButton() {
    if ($('.js--add-to-autoship-order').length > 0) {
        $('.js--add-to-autoship-order').attr('disabled',
            !$('.global-availability').data('ready-to-order') ||
            !$('.global-availability').data('available')
        );
    }
}

baseQuickView.showQuickview = function () {
    $('body').on('click', '.quickview', function (e) {
        e.preventDefault();
        var selectedValueUrl = $(this).closest('a.quickview').attr('href');
        $(e.target).trigger('quickview:show');
        getModalHtmlElement();
        fillModalElement(selectedValueUrl);
    });

    $('body').on('click', '.js--autoship-product-search-result .image-container', function (e) {
        e.preventDefault();
        $('.js--autoship-product-search-result').spinner().start();
        var selectedValueUrl = $(this).find('a.quickview').attr('href');
        $(e.target).trigger('quickview:show');
        getModalHtmlElement();
        fillModalElement(selectedValueUrl);
    });
};

baseQuickView.updateAvailability = function () {
    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);

        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
        updatedAddToAutoshipOrderButton();
    });
};

baseQuickView.addproductToAutoshipOrder = function () {
    $(document).on('click', 'button.js--add-to-autoship-order', function (e) {
        e.preventDefault();
        var pid = base.getPidValue($(this));
        var quantity = $('select.quantity-select').val();
        var autoshipID = $('.js--autoshipID').val();
        var actionURL = $(this).attr('data-action');
        var urlString = actionURL + '?pid=' + pid + '&autoshipID=' + autoshipID + '&quantity=' + quantity;
        $('#quickViewModal').spinner().start();
        $.ajax({
            url: urlString,
            type: 'post',
            dataType: 'json',
            success: function (data) {
                if (data.success) {
                    $('#js--autoShipPliCOmponent').html(data.updateViewHtml);
                    $('#quickViewModal').modal('hide');
                    $('#quickViewModal').spinner().stop();
                    $('#addMoreProductsModal').modal('hide');
                    $('.js--editOrderBtnWrapper').hide();
                    $('.js--editOrderDetails').show();
                    updateSummary(data.priceDetails);
                    infoMessage(data.message);
                } else {
                    infoMessage(data.message, "error");
                    location.reload();
                }
            },
            error: function () {
                $('#quickViewModal').spinner().stop();
                $('body').spinner().stop();
            }
        });
    });
};

baseQuickView.purchaseOptionHandler = () => {
    $(document).on('change', 'input[name="purchase-method"]', (e) => {
        $('.custom--select--dropdown').addClass('d-none');
        $(e.target).closest('.form-check').find('.custom--select--dropdown').removeClass('d-none');
        if ($(e.target).attr('id') !== 'freeLocalPickup' && !$('.selected-store-with-inventory').hasClass('display-none')) {
            $('#remove-store-selection').click();
        }
        const $container = $(e.target).closest('.product-detail');
        const available = $container.find('.product-available').val();
        $container.find('.add-to-cart').prop('disabled', $(e.target).attr('id') === 'freeLocalPickup' || !available || available === 'false');
    });

    $(document).on('click', '.purchase-option-container', (e) => {
        $(e.target).find('input[type=radio]').prop('checked', true).trigger('change');
    });

    const $selectedInput = $('input[name="purchase-method"]:checked');
    $selectedInput.closest('.form-check').find('.custom--select--dropdown').removeClass('d-none');

    if ($selectedInput.attr('id') === 'freeLocalPickup') {
        $('.add-to-cart').prop('disabled', true);
    }
};

baseQuickView.updateAutoshipPrice = () => {
    $(document).on('change', '.product-type-option', (e) => {
        $.spinner().start();
        const autoShipPriceURL = $('.purchase-option-container.autoship-section').data('autoship-price-url');
        const pid = base.getPidValue($(e.currentTarget));// $('.add-to-cart').data('pid');
        const isAutoshipPrice = $(e.target).hasClass('autoship-option');

        fetch(`${autoShipPriceURL}?${new URLSearchParams({
            pid,
            isAutoshipPrice,
        })}`)
            .then((response) => response.json())
            .then((data) => {
                $('.price', '#quickViewModal').replaceWith(data.productPrice);
                $.spinner().stop();
            })
            .catch(() => $.spinner().stop());
    });
};

baseQuickView.afterAtributeSelect = () => {
    $('body').on('product:afterAttributeSelect', (e, response) => {
        const isAutoshipPrice = $('.product-type-option').length > 0 ? $('.product-type-option:checked').hasClass('autoship-option') : false;

        if (isAutoshipPrice && response.data && response.data.product
            && response.data.product.autoshipPrice) {
            $('.price', response.container).replaceWith(response.data.product.renderedAutoshipPrice);
        }
    });
};

baseQuickView.allowQuantityNumbers = () => {
    $('.quantity-select').on('keydown', (e) => {
        const invalidChars = ['-', '+', 'e', 'E', '.'];
        if (invalidChars.includes(e.key)) {
            e.preventDefault();
        }
        return true;
    });
};

function infoMessage(message, messageType) {
    var messageType = messageType ? 'alert-danger' : 'alert-success';
    if ($('.autoship-messages').length === 0) {
        $('body').append(
            '<div class="autoship-messages add-to-cart-messages"></div>'
        );
    }

    $('.autoship-messages').append(
        '<div class="alert ' + messageType + ' autosship-info-alert add-to-basket-alert text-center" role="alert">'
        + message
        + '</div>'
    );

    setTimeout(function () {
        $('.autosship-info-alert').remove();
    }, 5000);

}

function updateSummary(priceDetails) {
    if (priceDetails) {
        let subTotal = priceDetails.subTotal ? priceDetails.subTotal : '-';
        let shipping = priceDetails.shipping ? priceDetails.shipping : '-';
        let tax = priceDetails.tax != null ? priceDetails.tax : '-';
        let orderTotal = priceDetails.orderTotal ? priceDetails.orderTotal : '-';
        $('.js--autoshipSubTotal').text(subTotal);
        $('.js--autoshipShippingCost').text(shipping);
        $('.js--autoshipTax').text(tax);
        $('.js--autoshipGrandTotal').text(orderTotal);
    }
}

module.exports = baseQuickView;